import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ScopedBlockLabels, useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import {
    LabelSeverity as LabelSeverityStoreContext, LabelWithNamedArguments as LabelWithNamedArgumentsStoreContext,
} from '@/storecontext/shared/api/server-apis';
import {
    LabelWithNamedArguments as LabelWithNamedArgumentsProduct,
} from '@/types/productServerApi';
import { computed, ComputedRef } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockLabelWithNamedArguments',
  props: {
    label: null,
    namespace: { default: undefined },
    tag: { default: 'div' }
  },
  setup(__props: any) {

const props = __props as { label: LabelWithNamedArgumentsStoreContext | LabelWithNamedArgumentsProduct, namespace: ScopedBlockLabels, tag: string }



const labels = useBlockLabels(props.namespace);
const formattedHtml: ComputedRef<string> = computed(() => dictionaryService.formatNamed(labels[props.label.label], props.label.namedParams));
const isErrorColor: ComputedRef<boolean> = computed(() => props.label.severity === LabelSeverityStoreContext.Warning);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), {
    class: _normalizeClass({ 'text-roman': _unref(isErrorColor) }),
    innerHTML: _unref(formattedHtml)
  }, null, 8, ["class", "innerHTML"]))
}
}

})